<template lang="pug">
Card.selections-card
  template(#header)
    .title {{ $t('selections.userBER.title') }}
  template(#content)
    SearchInput(
      v-model="ber" 
      :placeholder="$t('selections.userBER.placeholder')" 
      :submit-label="$t('selections.userBER.button')" 
      :loading="isLoading"
      @keyup="onKeyUp"
      @search="search()")
    SelectionErrorMessage(v-if="errorMessage" :message="errorMessage")
    BERTypologyInfo(v-if="berData" :ber-data="berData")


</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import Card from "primevue/card";
import SearchInput from "@/components/forms/components/SearchInput.vue";
import SelectionErrorMessage from "@/components/forms/components/SelectionErrorMessage.vue";
import BERTypologyInfo from "./BERTypologyInfo.vue";

import { useSelections } from "@/store";
import { storeToRefs } from "pinia";
import { LayoutEvent, emit } from "@/helpers";

export default defineComponent({
  components: {
    Card,
    SearchInput,
    SelectionErrorMessage,
    BERTypologyInfo,
  },
  setup() {
    const selection = useSelections();
    const { loadBerData } = selection;
    const { houseTypologySelected, berData } = storeToRefs(selection);

    const isLoading = ref(false);
    const ber = ref<string>();
    const errorMessage = ref<string>();

    function onKeyUp(event: KeyboardEvent) {
      if (event.key === "Enter") {
        search();
      } else {
        ber.value = ber.value?.replace(/[^\d]/g, "");
      }
    }

    async function search() {
      errorMessage.value = undefined;
      emit(LayoutEvent.ShowHouseInfoForm, false);
      try {
        isLoading.value = true;
        await loadBerData(parseInt(ber.value || ""));
        ber.value = "";
      } catch (e) {
        if (e instanceof Error) {
          errorMessage.value = e.message;
        }
      }

      isLoading.value = false;
    }
    return {
      ber,
      isLoading,
      errorMessage,
      houseTypologySelected,
      berData,
      search,
      onKeyUp,
    };
  },
});
</script>
<style scoped lang="scss">
.wrapper {
  align-items: center;

  .ber-error {
    bottom: 2rem;
    padding: 0.5rem;
    font-size: small;
  }
}
</style>
